document.addEventListener('DOMContentLoaded', function() {
  const copyButton = document.getElementById('copyButton')
  const tagText = document.getElementById('tagText')
  const message = document.getElementById('message')
  
  // クリップボードへコピー（ボタンをクリックした時）
  copyButton.addEventListener('click', () => {
    const tagValue = tagText.value
    copyToClipboard(tagValue)
  })
  
  // クリップボードへコピー（コピーの処理）
  function copyToClipboard (tagValue) {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(tagValue).then(function () {
        messageActive()
      })
    } else {
      tagText.select()
      document.execCommand('copy')
      messageActive()
    }
  }
  
  // メッセージを表示
  function messageActive () {
    message.classList.add('is-active')
    setTimeout(() => {
      message.classList.remove('is-active')
    }, 4000)
  }
});